import React from 'react';
export function DesktopIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 15V4a2 2 0 012-2h18a2 2 0 012 2v11a2 2 0 01-2 2h-8l1 3h2a1 1 0 011 1v1H7v-1a1 1 0 011-1h2l1-3H3a2 2 0 01-2-2zm2 0V4h18v11H3z"
  }));
}